import React, { useState, useEffect } from 'react'
import InputText from '../input-text/input-text'
import inputProptypes from '../input-proptype'
import { useInitialValueToValidation } from '../custom-hooks'
import { Button, CustomStyle } from './style'

const InputPassword = ({
  hasCustomError,
  isValidPassword,
  invalidPasswordMessage,
  required,
  value,
  onChange,
  onBlur,
  customErrorMessage,
  ...rest
}) => {
  const [currentMessage, setCurrentMessage] = useState('')
  const [visible, setVisible] = useState(false)

  const handleOnBlur = value => {
    if (onBlur) onBlur({ value })
  }

  const handleOnChange = async ({ value, id, name }) => {
    if (onChange) await onChange({ value, id, name })

    return value
  }
  const changeVisible = e => {
    setVisible(!visible)
  }

  const inputProps = {
    type: visible ? 'text' : 'password',
    onChange: handleOnChange,
    onBlur: handleOnBlur,
    errorMessage: currentMessage,
    required,
    hasError: hasCustomError || !isValidPassword,
    value,
    internClassName: 'input-password',
    ...rest,
  }

  useEffect(() => {
    if (hasCustomError) return setCurrentMessage(customErrorMessage)
    if (!isValidPassword) return setCurrentMessage(invalidPasswordMessage)
    setCurrentMessage('')
  }, [hasCustomError, isValidPassword])

  return (
    <>
      <CustomStyle />
      <InputText fixedLabel {...inputProps} customButton={<Button type="button" visible={visible} onClick={changeVisible} />} />
    </>
  )
}

InputPassword.propTypes = inputProptypes

export default InputPassword
